import { ChangeEvent, FC, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { registerUser } from "../../api/common";
import SubmitButton from "../../Components/Button";
import LoadingOverlay from "../../Components/LoadingOverlay";
import SelectBox from "../../Components/SelectBox";
import TextInput from "../../Components/TextInput";
import {
  ERROR_MESSAGE,
  ROLE_OPTIONS,
  SUCCESS_MESSAGE,
  VALIDATION_ERROR_MESSAGE,
} from "../../constants";
import styles from "./style.module.scss";
import Alert from "../../Components/AlertPopup";

interface StatePorps {
  onClose: (data: any) => void;
  showModal?: boolean;
}

const CreateUserModal: FC<StatePorps> = ({ showModal = false, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [validated, setValidated] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [supervisorEmail, setSupervisorEmail] = useState("");

  const onCloseClick = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onClose(false);
  };

  const handleClose = () => {
    setShowToast(false);
    onClose(false);
  };
  const handleErrorClose = () => setShowErrorToast(false);

  const handleSubmit = async (event: ChangeEvent<HTMLFormElement>) => {
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      const formData = {
        roleType: role,
        name,
        email,
        username,
        supervisorEmail,
      };
      setLoading(true);
      registerUser(formData)
        .then((response) => {
          setShowToast(true);
          //form reset
          setValidated(false);
          setName("");
          setEmail("");
          setUsername("");
          setRole("");
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          setErrorMessage(ERROR_MESSAGE.API_ERROR_MESSAGE);
          setShowErrorToast(true);
        });
    }

    setValidated(true);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <>
      <Modal size="lg" show={showModal} onHide={() => onClose(false)}>
        <LoadingOverlay loading={loading} />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              <Alert
                type="error"
                show={showErrorToast}
                onClose={handleErrorClose}
                message={ErrorMessage}
              />

              <Alert
                show={showToast}
                onClose={handleClose}
                message={SUCCESS_MESSAGE.USER_CREATED_SUCCESS}
              />
              <div className="modalTitle">Add User</div>
              <div className="modalSubtitle">
                &nbsp;<span className="mandatory">*</span> All are mandatory
                fields
              </div>
            </Modal.Title>
          </Modal.Header>
          <br />
          <Modal.Body>
            <Row className={styles.rows}>
              <Col xs={12} md={4} className={styles.loginLabel}>
                <Form.Label>
                  Name&nbsp;<span className="mandatory">*</span>
                </Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <TextInput
                  name="name"
                  id="name"
                  value={name}
                  required={true}
                  errrorMessage={VALIDATION_ERROR_MESSAGE.VENDOR_NAME_EMPTY}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    setName(event.currentTarget.value);
                  }}
                />
              </Col>
            </Row>

            <Row className={styles.rows}>
              <Col xs={12} md={4} className={styles.loginLabel}>
                <Form.Label>
                  Username&nbsp;<span className="mandatory">*</span>
                </Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <TextInput
                  name="username"
                  id="username"
                  value={username}
                  required={true}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    setUsername(event.currentTarget.value);
                  }}
                />
              </Col>
            </Row>
            <Row className={styles.rows}>
              <Col xs={12} md={4} className={styles.loginLabel}>
                <Form.Label>
                  Email&nbsp;<span className="mandatory">*</span>
                </Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <TextInput
                  name="email"
                  id="email"
                  value={email}
                  required={true}
                  errrorMessage={VALIDATION_ERROR_MESSAGE.VENDOR_EMAIL_EMPTY}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    setEmail(event.currentTarget.value);
                  }}
                />
              </Col>
            </Row>
            <Row className={styles.rows}>
              <Col xs={12} md={4} className={styles.loginLabel}>
                <Form.Label>Supervisor Email&nbsp;</Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <TextInput
                  name="supervisoremail"
                  id="supervisoremail"
                  value={supervisorEmail}
                  errrorMessage={VALIDATION_ERROR_MESSAGE.VENDOR_EMAIL_EMPTY}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    setSupervisorEmail(event.currentTarget.value);
                  }}
                />
              </Col>
            </Row>
            <Row className={styles.rows}>
              <Col xs={12} md={4} className={styles.loginLabel}>
                <Form.Label>
                  Role&nbsp;<span className="mandatory">*</span>
                </Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <SelectBox
                  options={ROLE_OPTIONS}
                  name="role"
                  id="role"
                  required={true}
                  errrorMessage={VALIDATION_ERROR_MESSAGE.ROLE_EMPTY_ERROR}
                  onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                    setRole(event.currentTarget.value);
                  }}
                  defaultValue={role}
                />
              </Col>
            </Row>
          </Modal.Body>
          <br />
          <br />
          <Modal.Footer className="alignRight">
            <SubmitButton type="secondary" onClick={onCloseClick}>
              Close
            </SubmitButton>
            <SubmitButton>Save</SubmitButton>
          </Modal.Footer>
        </Form>
        <br />
      </Modal>
    </>
  );
};

export default CreateUserModal;
